module.exports = __webpack_public_path__ + "img/CH.f92f4d67.svg";